import { Directive, ElementRef, HostListener } from '@angular/core';
import { Util } from '../utils/util';

@Directive({
  selector: '[appTelefone]'
})
export class TelefoneDirective  {
  lastValue: string;

  constructor(public ref: ElementRef) {
  }

  @HostListener('input', ['$event']) onInput(event) {
    const telefone = event.target.value;
    const numero = telefone.replace(/\D/g, '');
    if (numero.length > 11) {
      this.ref.nativeElement.value = this.lastValue || '';
      return;
    }

    const resEventValue = Util.aplicarMascaraTelefone(telefone);
    this.lastValue = resEventValue;
    this.ref.nativeElement.value = resEventValue;
    if (event.target.value !== resEventValue) {
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('input', false, true);
      event.target.dispatchEvent(evt);
    }
  }

}
